"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = exports.Content = exports.Wrapper = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var theme_1 = require("../../../theme");
var typography_1 = require("../../typography");
var PADDING = {
    '1': { small: '12px 16px', medium: '20px 24px', large: '24px 32px' },
    '2': { small: '12px 16px', medium: '12px 16px', large: '16px 24px' },
    '3': { small: '12px 16px', medium: '12px 16px', large: '12px 16px' },
};
exports.Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: ", ";\n  border-radius: 10px;\n  background-color: ", ";\n\n  @media ", " {\n    padding: ", ";\n  }\n\n  @media ", " {\n    padding: ", ";\n  }\n"], ["\n  padding: ", ";\n  border-radius: 10px;\n  background-color: ", ";\n\n  @media ", " {\n    padding: ", ";\n  }\n\n  @media ", " {\n    padding: ", ";\n  }\n"])), function (_a) {
    var $level = _a.$level;
    return PADDING[$level].small;
}, function (_a) {
    var $backgroundColor = _a.$backgroundColor;
    return theme_1.theme.colors[$backgroundColor];
}, theme_1.theme.breakpoints.medium, function (_a) {
    var $level = _a.$level;
    return PADDING[$level].medium;
}, theme_1.theme.breakpoints.large, function (_a) {
    var $level = _a.$level;
    return PADDING[$level].large;
});
exports.Content = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
exports.Label = (0, styled_components_1.default)(typography_1.Label)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  line-height: ", ";\n\n  @media ", " {\n    line-height: ", ";\n  }\n\n  @media ", " {\n    line-height: ", ";\n  }\n"], ["\n  line-height: ", ";\n\n  @media ", " {\n    line-height: ", ";\n  }\n\n  @media ", " {\n    line-height: ", ";\n  }\n"])), function (_a) {
    var $lineHeight = _a.$lineHeight;
    return (($lineHeight === null || $lineHeight === void 0 ? void 0 : $lineHeight.small) ? "".concat($lineHeight.small, "px") : 'auto');
}, theme_1.theme.breakpoints.medium, function (_a) {
    var $lineHeight = _a.$lineHeight;
    return (($lineHeight === null || $lineHeight === void 0 ? void 0 : $lineHeight.medium) ? "".concat($lineHeight.medium, "px") : 'auto');
}, theme_1.theme.breakpoints.large, function (_a) {
    var $lineHeight = _a.$lineHeight;
    return (($lineHeight === null || $lineHeight === void 0 ? void 0 : $lineHeight.large) ? "".concat($lineHeight.large, "px") : 'auto');
});
var templateObject_1, templateObject_2, templateObject_3;
